import type { ReactNode } from 'react';

export const symbol_account_child_invert: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-880q51 0 85.5 34.5T600-760q0 51-34.5 85.5T480-640q-51 0-85.5-34.5T360-760q0-51 34.5-85.5T480-880Zm0 280q46 0 92 12t83 32q38 20 61.5 46.5T740-453v231q0 37-23.5 64T657-131q-10 0-17-7t-7-26v-37q0-38-50.5-60.5T480-284q-43 0-84 14t-61 37q-6 8-3 17t13 13q32 11 67 15t71 5q22 0 37 15t15 37q0 22-15 37t-37 15q-35 0-80.5-7.5T316-111q-41-17-68.5-44T220-222v-231q0-30 23-56.5t61-46.5q38-20 84-32t92-12Zm0 240q35 0 57.5-22.5T560-440q0-35-22.5-57.5T480-520q-35 0-57.5 22.5T400-440q0 35 22.5 57.5T480-360Z"
		/>
	</svg>
);
